export default "__VITE_ASSET__CZdPtVsA__"